import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { CallbackComponent } from './modules/callback/callback.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule), pathMatch: 'full'  },
  { path: 'iss-form', loadChildren: () => import('./modules/iss-form/iss-form.module').then(m => m.IssFormModule) },
  { path: 'register', loadChildren: () => import('./modules/register/register.module').then(m => m.RegisterModule) },
  { path: 'documents', loadChildren: () => import('./modules/documents/documents.module').then(m => m.DocumentsModule) },
  { path: 'thankyou', loadChildren: () => import('./modules/thankyou/thankyou.module').then(m => m.ThankyouModule) },
  { path: 'corporate', loadChildren: () => import('./modules/corporate/corporate.module').then(m => m.CorporateModule) },
  { path: 'ExistingClient', loadChildren: () => import('./modules/existing-client/existing-client.module').then(m => m.ExistingClientModule) },
  { path: 'CorporateDisclaimer', loadChildren: () => import('./modules/corp-disclaimer/corp-disclaimer.module').then(m => m.CorpDisclaimerModule) },
  // { path: 'login', loadChildren: './modules/signup/signup.module#SignupModule' },
  { path: 'callback', component: CallbackComponent },
  { path: 'Dashboard', loadChildren: () => import('./modules/dashboard-data/dashboard-data.module').then(m => m.DashboardDataModule),canActivate: [AuthGuard] },
  { path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload',
    scrollPositionRestoration: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
